import { ExternalAppIFrame } from "../ExternalAppIFrame/ExternalAppIFrame";

export default function CreateTemplate() {
	// const serverURL = import.meta.env.VITE_LYNKIT_DYNAMIC_FORM_REDIRECT_URL;
	const serverURL = "https://form.lynkit.in/login"
	const action = "/templates";
	return <ExternalAppIFrame serverURL={serverURL} action={action} />;
}
